import React, { useEffect } from "react";
import "./Home.css";
import logo from "../../assets/imgs/DiningRD_Logo_2025.png";
import {
  UnauthenticatedTemplate,
  AuthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { Link, useOutletContext } from "react-router-dom";
import BaseContent from "../shared/baseContent/BaseContent";
import Button from "@mui/material/Button";
import { loginRequest } from "authConfig";
import { List, ListItem } from "@mui/material";
import { useGetPermissionsQuery } from "store/apis/AccountApi";
import { selectHasMarketplace, setHasMarketplace, setPermissions } from "store/slices/appSlice/AppSlice";
import { useDispatch, useSelector } from "react-redux";
import { EditSkeleton } from "components/admin/admin.overlays";
import useMsalAccount from "utils/useMsalAccount";
import { Roles } from "components/shared/constants";

export default function Home() {
  const currentUserData = useOutletContext();
  const dispatch = useDispatch();
  const { instance } = useMsal();
  const { roles: userRoles } = useMsalAccount();
  const hasOrderManagement = userRoles.some((role) => [Roles.Admin, Roles.Menu_Team, Roles.Tableside_Setup_User].includes(role));
  const hasMarketplace = useSelector(selectHasMarketplace);

  const { 
    data: permissions, 
    isFetching: permissionsLoading 
  } = useGetPermissionsQuery({}, //no params, empty object for args
    { skip: !currentUserData }
  );

  useEffect(() => {
    if (!permissionsLoading && permissions && permissions.length >= 0) {
      dispatch(setPermissions(permissions));
      dispatch(setHasMarketplace(permissions.includes("Marketplace")));
    }
  }, [permissions, permissionsLoading, dispatch]);

  const handleLogin = async () => {
    await instance.loginRedirect({ ...loginRequest, prompt: "login" });
  };

  return (
    <BaseContent disableBack={true}>
      <AuthenticatedTemplate>
        <div className="authenticatedHomePage">
          <div className="logoHeader">
            <img className="centerLogo" src={logo} />
          </div>
            <>
            <div style={{width: '100%'}}>
              {!permissions ? (
                <EditSkeleton text={"Loading User Profile"} />
              ) : (
                <List>
                  <ListItem className="homeButton">
                    <Button
                      component={Link}
                      to="/takeorder/residents"
                      color={"primary"}
                      className="baseButton"
                      variant="contained"
                      sx={{
                        width: '100%', 
                        height: '2.25rem'
                      }}
                    >
                      TAKE ORDERS
                    </Button>
                  </ListItem>

                  {!!permissions && hasMarketplace && (
                    <ListItem className="homeButton">
                      <Button
                        component={Link}
                        to="/marketplace/residents"
                        className="baseButton"
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: "2.25rem",
                          backgroundColor: "#fac432",
                          color: "#000"
                        }}
                      >
                        MARKETPLACE
                      </Button>
                    </ListItem>
                  )}
                  {hasOrderManagement && (
                    <ListItem className="homeButton">
                      <Button
                        component={Link}
                        to="/ordermanagement/residents"
                        className="baseButton"
                        variant="contained"
                        sx={{
                          width: "100%",
                          height: "2.25rem",
                          backgroundColor: "#01617e",
                          color: "#fff"
                        }}
                      >
                        ORDER MANAGEMENT
                      </Button>
                    </ListItem>
                  )}
                </List>
              )}
            </div>
            <div className="activeUserContainer">
              {/*eslint-disable-next-line no-undef */}
              <p>v {process.env.REACT_APP_VERSION}</p>
              <p>{currentUserData?.emailAddress || ""}</p>
            </div>
          </>
        </div>
      </AuthenticatedTemplate>
      {/* Should never see this as the base route is protected by forced redirect login */}
      <UnauthenticatedTemplate>
        <div className="unauthenticatedHomePage">
          <div className="logoHeader">
            <img className="centerLogo" src={logo} />
            <div className="loginMessage">
              <Button
                component={Link}
                color={"primary"}
                className="baseButton"
                variant="contained"
                onClick={handleLogin}>
                Click here to login
              </Button>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </BaseContent>
  );
}
